import React, { useEffect, useState } from "react";
import {
  FaBookBible,
  FaGraduationCap,
  FaSpinner,
  FaWhatsapp,
} from "react-icons/fa6";
import { LiaTimesCircle } from "react-icons/lia";
import { getWelcomeInfo, setWelcomeInfo } from "../../../AppManager";

export default function EditWelcomeInfo() {
  const [formData, setFormData] = useState({
    link: "",
    certificate: 0,
    manual: 0,
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({
    status: "",
    type: "",
    message: "",
  });

  useEffect(() => {
    getWelcomeInfo()
      .then((data) => setFormData(data))
      .catch((err) => err);
  }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((oldFormData) => ({ ...oldFormData, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await setWelcomeInfo(formData);
      if (res === "Updated") {
        setStatus({
          status: "success",
          type: "success",
          message: "Info. Updated",
        });
        setLoading(false);
      } else {
        setStatus({
          status: "error",
          type: "failed",
          message: "Update Failed",
        });
        setLoading(false);
      }
    } catch (error) {
      setStatus({ status: "error", type: "failed", message: "Update Failed" });
      setLoading(false);
    }
  }

  useEffect(() => {
    if (status.message !== "") {
      document
        .getElementById("status-wrapper")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [status]);

  document.title = "Edit Info";

  return (
    <div className="formwrapper" style={{ margin: "50px 0" }}>
      <div className="wrapper">
        <div className="form-box login">
          <h2>Edit Info</h2>
          <form onSubmit={handleSubmit}>
            {status.message !== "" && (
              <p className="status-wrapper" id="status-wrapper">
                <span className={`status-message ${status.type}`}>
                  {status.message}
                </span>
                <LiaTimesCircle
                  className="status-close"
                  onClick={() => {
                    setStatus({ status: "", type: "", message: "" });
                  }}
                />
              </p>
            )}
            <div className="input-box">
              <span className="icon">
                <FaWhatsapp />
              </span>
              <input
                readOnly={loading}
                type="text"
                onChange={handleChange}
                value={formData.link}
                autoComplete="off"
                required
                name="link"
                placeholder=" "
              />
              <label>WhatsApp Group Link</label>
            </div>
            <div className="input-box">
              <span className="icon">
                <FaGraduationCap />
              </span>
              <input
                readOnly={loading}
                type="number"
                onChange={handleChange}
                value={formData.certificate}
                autoComplete="off"
                required
                name="certificate"
                placeholder=" "
              />
              <label>Certificate Fee</label>
            </div>
            <div className="input-box">
              <span className="icon">
                <FaBookBible />
              </span>
              <input
                readOnly={loading}
                type="number"
                onChange={handleChange}
                value={formData.manual}
                autoComplete="off"
                required
                name="manual"
                placeholder=" "
              />
              <label>Manual Fee</label>
            </div>
            <button type="submit" disabled={loading} className="btn">
              {loading ? <FaSpinner className="spinner" /> : "Update"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
